import React, { useState } from 'react';

import { deleteSasProposta } from '@app/api/sas/sasProposta';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';

interface Props {
  id: string;
  idOrdemCompra: string;
}

const ModalExcluirVendor = (props: Props) => {
  const { id, idOrdemCompra } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleExcluir = (values: any) => {
    deleteSasProposta(id, values.justificativa).then(data => {
      if (data.valid) {
        window.location.href = `${window.origin}/ordemCompra/${idOrdemCompra}/dadosGerais`;
      }
    });
  };

  const handleCancel = () => {
    setExibirModal(false);
  };

  return (
    <>
      <Button 
        type="danger" 
        onClick={() => setExibirModal(true)}
        style={{ float: 'right' }}
      >
        Excluir Proposta
      </Button>
      <Modal title="Excluir a proposta" width="680px" visible={exibirModal} onCancel={handleCancel} footer={null}>
        {exibirModal && (
          <MasterDetailForm
            onSubmit={handleExcluir}
            actions={[
              <Button type="link" onClick={handleCancel} key="close">
                Fechar
              </Button>,
              <FormSubmitButton noIcon type="primary" key="save" onSubmit={e => handleExcluir(e)}>
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormTextArea label="Justificativa da exclusão" name="justificativa" span={12} rows={4} required />
              </Row>
            </Widget>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};
export default ModalExcluirVendor;
